// this needs to be the first import since it determines the cdn location of resources
import "./publicPath.ts";

import * as Sentry from "@sentry/browser";
import "core-js/web";
import "whatwg-fetch";
import "./helpers/nodelist-foreach-polyfill";
import "./i18n/i18n";
import {ProductList} from "./components/productList";
import {RootBannerSection} from "./components/swipers/rootBannerSection";
import {LoadFlashsales} from "./components/loadFlashsales";
import {RootFlashsaleSection} from "./components/swipers/rootFlashsaleSection";
import {TeaserSlider} from "./components/swipers/teaserSlider";
import {BlogImageSwiper} from "./components/swipers/blogImageSwiper";
import {ProductSwiper} from "./components/swipers/productSwiper";
import {BlogGallerySwiper} from "./components/swipers/blogGallerySwiper";
import {BwareSwiper} from "./components/swipers/bwareSwiper";
import {GenericSwiper} from "./components/swipers/genericSwiper";
import {ShopRatingHandler} from "./components/ShopRating/shopRatingHandler";
import PinitComponent from "./components/pinitComponent";
import {init as initCart} from "./index-cart";
import EnergyLabelPortal from "./components/energyLabel/EnergyLabelPortal";
import NewsletterRegistrationPagePortal from "./components/newsletter/NewsletterRegistrationPagePortal";
import {ProductBundleHandler} from "./components/ProductView/PdpBundle";
import {beforeBreadcrumb} from "./helpers/sentryHelper";
import PublitasPortal from "./components/catalogues/PublitasPortal";
import GiftBlockPortal from "./components/giftBlock/GiftBlockPortal";

Sentry.init({
  dsn: "https://17a766be243d431cb89d9487d11259fe@sentry.io/1299670",
  beforeBreadcrumb,
});

// Disable Sentry in dev mode
if (__DEVELOPMENT__) {
  const hub = Sentry.getCurrentHub().getClient();

  if (hub) {
    hub.getOptions().enabled = false;
  }

  // eslint-disable-next-line no-console
  console.log("%cDevelopment", "color: red; font-size: x-large;");
}

initCart();

// Filter lists i.e. on productsubcategories
// region product list

const productList: HTMLElement | null = document.querySelector(".js-product-list-infinite");
const productListMoreButton: HTMLElement | null = document.querySelector(".js-more-exist");
if (productList && productListMoreButton) {
  new ProductList(productList, productListMoreButton);
}

// endregion product list

// Initialisierung Swiper Homepage
const bannerSection: HTMLElement | null = document.getElementById("BannerSection");
if (bannerSection !== null) {
  new RootBannerSection(bannerSection);
}

const flashsaleSection: HTMLElement | null = document.getElementById("FlashsaleSection");
if (flashsaleSection !== null) {
  LoadFlashsales.load().then((flashSaleData) => {
    new RootFlashsaleSection(flashsaleSection, flashSaleData);
  }, Sentry.captureException);
}

// Product slider in blog entries
const swiperProducts: NodeListOf<HTMLDivElement> | null = document.querySelectorAll(".swiper-products");
if (swiperProducts.length > 0) {
  swiperProducts.forEach((swiper) => {
    new TeaserSlider(swiper);
  });
}

// Blog images, Coverflow style
const swiperBlogImages: NodeListOf<HTMLDivElement> = document.querySelectorAll(".swiper-blog-images");
if (swiperBlogImages.length > 0) {
  swiperBlogImages.forEach((swiper) => {
    new BlogImageSwiper(swiper);
  });
}

// Initialisierung Swiper Produktseiten
const swiperContainerProduct: Element = document.getElementsByClassName("swiper-container-product")[0];
const zoomAnchorList: HTMLCollectionOf<Element> = document.getElementsByClassName("gallery-zoom");
if (swiperContainerProduct !== null) {
  new ProductSwiper(swiperContainerProduct, zoomAnchorList);
}

// Initialisierung Swiper Blog-Einträge - Galerie
const gallerySwiper: HTMLDivElement | null = document.querySelector(".swiper-container-gallery");
if (gallerySwiper !== null) {
  new BlogGallerySwiper(gallerySwiper);
}

// Alle Swiper B-Waren-Seite
const galleryLinkCollection = document.querySelectorAll<HTMLAnchorElement>(".gallery-link");
if (galleryLinkCollection.length > 0) {
  galleryLinkCollection.forEach((anchor) => {
    new BwareSwiper(anchor);
  });
}

// Sonstige Swiper suchen und initialisieren (zzt nur auf der ConnoxPlus welcome page )
const genericSwiper: NodeListOf<HTMLElement> = document.querySelectorAll(".swiper-container-generic");
if (genericSwiper.length > 0) {
  new GenericSwiper(genericSwiper);
}

// Asynchronous shoprating loading
const shopRatingElement: HTMLElement | null = document.querySelector("[data-react-rating]");
const headlineRating: HTMLElement | null = document.querySelector(".product-rating");
if (shopRatingElement) {
  ShopRatingHandler.run(shopRatingElement, headlineRating);
}

const blogEntryContentElement = document.querySelector<HTMLElement>(".blog-entry__content");
if (blogEntryContentElement) {
  PinitComponent.pinit(blogEntryContentElement);
}

const newsletterRegistrationPage = document.getElementById("newsletter-landing-page");
if (newsletterRegistrationPage) {
  NewsletterRegistrationPagePortal.run(newsletterRegistrationPage);
}

const energyLabelElements = document.querySelectorAll<HTMLElement>("[data-energy-class]");
if (energyLabelElements.length) {
  EnergyLabelPortal.run(energyLabelElements);
}

const productBundleContainer = document.getElementById("product-bundle-container");
if (productBundleContainer) {
  ProductBundleHandler.run(productBundleContainer as HTMLDivElement);
}

const publitasContainer = document.getElementById("publitas-embed-generic-container");
if (publitasContainer) {
  PublitasPortal.run(publitasContainer as HTMLDivElement);
}

const giftBlockContainer = document.querySelector<HTMLDivElement>(".react-gift-block");
if (giftBlockContainer) {
  GiftBlockPortal.run(giftBlockContainer);
}
